import { commitMutation,
  graphql } from 'react-relay';
import environment from '../../index';
import { basicMutationOnCompleted, onErrorMutation } from '../common/common';

const mutation = graphql`
mutation CreateTeamMutation($name: String!) {
  createTeam(teamName: $name) { 
    ok
    error
    teamId
  }
}
`;

export default ({ name }, done) => {
  const variables = { name };

  commitMutation(
    environment(),
    {
      mutation,
      variables,
      updater: (store, { createTeam }) => {
        const { ok, error, teamId } = createTeam;
        if (!ok || error) return;
        const root = store.get('userTeam');
        root.setValue(teamId, 'teamId');
        root.setValue(name, 'name');
      },
      onCompleted: ({ createTeam }) => basicMutationOnCompleted(createTeam, done),
      onError: error => onErrorMutation(error, done)
    }
  );
};
